import React from "react";

const ImportWithProgress = () => {
  return (
    <div style={{ padding: 0, margin: 0 }}>
      <iframe
        src="https://suppressionagent.livauto.com/database-transaction/database-transaction.php"
        style={{
          width: "100%",
          height: "100vh",
          border: "none",
        }}
        title="Import With Progress"
      ></iframe>
    </div>
  );
};

export default ImportWithProgress;
